class BlogPostSection {
  constructor(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.slideshow = null;
    this.mobileBreakpoint = 768;
    this.init();
  }

  init() {
    setTimeout(() => {
      this.initializeSlideshow();
      this.setupResponsiveGridCols();
      this.bindEvents();
    }, 100);
  }

  initializeSlideshow() {
    const swiperContainers = this.container.querySelectorAll('.blog-post__slideshow');
    if (!swiperContainers.length) return;

    if (typeof Swiper === 'undefined') {
      console.warn('Swiper is not loaded');
      return;
    }

    swiperContainers.forEach(swiperContainer => {
      const swiperOptions = JSON.parse(swiperContainer.dataset.swiperOptions || '{}');
      const desktopPosts = parseInt(swiperContainer.closest('.blog-post-products-wrapper')?.dataset.desktopProducts) || 3;
      const mobilePosts = parseInt(swiperContainer.closest('.blog-post-products-wrapper')?.dataset.mobileProducts) || 1;

      const defaultOptions = {
        slidesPerView: mobilePosts,
        spaceBetween: 20,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: swiperContainer.querySelector('.blog-post__slideshow-next'),
          prevEl: swiperContainer.querySelector('.blog-post__slideshow-prev'),
        },
        pagination: {
          el: swiperContainer.querySelector('.blog-post-pagination'),
          type: "progressbar",
        },
        breakpoints: {
          0: { slidesPerView: 1 },
          450: { slidesPerView: mobilePosts },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: desktopPosts }
        }
      };

      const finalOptions = { ...defaultOptions, ...swiperOptions };

      if (typeof Kinderly !== 'undefined' && Kinderly.Swiper) {
        Kinderly.Swiper.init(swiperContainer, finalOptions);
      } else {
        new Swiper(swiperContainer, finalOptions);
      }
    });
  }


  setupResponsiveGridCols() {
    const gridContainer = this.container.querySelector('.blog-post__grid');
    if (!gridContainer) return;

    const desktopCols = gridContainer.dataset.desktopCols || 3;
    const mobileCols = gridContainer.dataset.mobileCols || 1;
    gridContainer.style.setProperty('--desktop-cols', desktopCols);
    gridContainer.style.setProperty('--mobile-cols', mobileCols);
  }

  bindEvents() {
    this.resizeHandler = this.debounce(() => {
      this.handleResize();
    }, 250);

    window.addEventListener('resize', this.resizeHandler);
  }

  handleResize() {
    const swiperContainers = this.container.querySelectorAll('.blog-post__slideshow');
    swiperContainers.forEach(container => {
      if (container.swiper) {
        container.swiper.slides.forEach(slide => {
          slide.style.width = '';
          slide.style.marginRight = '';
        });
        container.swiper.update();
      }
    });
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  destroy() {
    const swiperContainers = this.container.querySelectorAll('.blog-post__slideshow');
    swiperContainers.forEach(container => {
      if (container.swiper) {
        container.swiper.destroy(true, true);
        container.swiper = null;
      }
    });
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
  }
}

const blogPostInstances = new Map();

document.addEventListener('DOMContentLoaded', () => {
  const blogPostSections = document.querySelectorAll('.blog-post-section');
  blogPostSections.forEach(section => {
    const sectionId = section.dataset.sectionId;
    const instance = new BlogPostSection(section);
    blogPostInstances.set(sectionId, instance);
  });
});

if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.blog-post-section');
    if (section) {
      const sectionId = section.dataset.sectionId;
      if (blogPostInstances.has(sectionId)) {
        blogPostInstances.get(sectionId).destroy();
      }
      const instance = new BlogPostSection(section);
      blogPostInstances.set(sectionId, instance);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('.blog-post-section');
    if (section) {
      const sectionId = section.dataset.sectionId;
      if (blogPostInstances.has(sectionId)) {
        blogPostInstances.get(sectionId).destroy();
        blogPostInstances.delete(sectionId);
      }
    }
  });
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = BlogPostSection;
}